<template>
    <div>
        <modal-intervention-view
        v-if="selectedEventId"
        :intervention-id="selectedEventId"
        />
            <!-- @unplanned="refreshInterventions" -->

        <modal name="modal-view-chantier" height="auto" :adaptive="true" width="1100px" classes="rounded-2xl shadow-2xl overflow-hidden">
            <div class="bg-white p-2">
                <div class="overflow-y-auto max-h-[90vh] min-h-[80vh] rounded-xl bg-gray-50/50 p-8">
                    <div v-if="selectedChantierId">
                        <div class="flex justify-between items-center mb-8">
                            <div class="flex items-center gap-3">
                                <div class="w-10 h-10 rounded-xl bg-orange-600 text-white flex items-center justify-center">
                                    <i class="fas fa-hard-hat text-sm"></i>
                                </div>
                                <h2 class="text-xl font-bold tracking-tight">Détails du chantier</h2>
                            </div>
                            <button @click="$modal.hide('modal-view-chantier')" class="w-9 h-9 rounded-lg hover:bg-slate-100 transition-all flex items-center justify-center text-slate-400 hover:text-red-500">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <chantier-view :chantier-id="selectedChantierId" />
                    </div>
                </div>
            </div>
        </modal>

        <!-- Modal planification -->
        <modal name="modal-planification" height="auto" :adaptive="true" width="1100px" classes="rounded-2xl shadow-2xl overflow-hidden">
            <div class="bg-white p-2">
                <div class="overflow-y-auto max-h-[90vh] min-h-[80vh] rounded-xl bg-gray-50/50 p-8">
                    
                    <!-- Header de la modal -->
                    <div class="flex justify-between items-start mb-6">
                        <div class="flex items-center gap-3">
                            <div class="w-10 h-10 rounded-xl bg-orange-600 text-white flex items-center justify-center shrink-0">
                                <i class="fas fa-calendar-alt text-sm"></i>
                            </div>
                            <div>
                                <h2 class="text-xl font-bold tracking-tight text-slate-900">Replanifier l'intervention</h2>
                                <!-- Rappel du motif d'annulation/replanification -->
                                <p v-if="selectedEvent?.replan_reason" class="text-xs text-red-600 bg-red-50 border border-red-100 px-2 py-1 rounded-md mt-1 inline-flex items-center gap-1">
                                    <i class="fas fa-exclamation-circle text-xs"></i> 
                                    Précédemment reporté car : <strong>{{ selectedEvent.replan_reason }}</strong>
                                </p>
                            </div>
                        </div>
                        <button @click="$modal.hide('modal-planification')" class="w-9 h-9 rounded-lg hover:bg-slate-100 transition-all flex items-center justify-center text-slate-400 hover:text-red-500">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <!-- Étape 1 : Choix du créneau sur le planning -->
                    <div v-if="!selectedSlotPlan">
                        <planning-half-day
                            :days="$account.account.societe.open_days"
                            :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                            heurefin-matin="12:00"
                            heure-debut-apres-midi="12:01"
                            :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                            @event-click="onEventClick"
                            @new-event="(selectedSlot) => { selectedSlotPlan = selectedSlot }"
                        />
                    </div>

                    <!-- Étape 2 : Récapitulatif et validation -->
                    <div v-if="selectedSlotPlan" class="space-y-4">
                        
                        <!-- Bandeau du nouveau créneau sélectionné -->
                        <div class="bg-slate-800 text-white rounded-xl p-4 flex items-center justify-between">
                            <div class="flex items-center gap-3">
                                <i class="fas fa-calendar-check text-xl text-emerald-400"></i>
                                <div>
                                    <p class="text-slate-400 text-xs uppercase tracking-wide">Nouveau créneau choisi</p>
                                    <p class="font-bold text-lg capitalize">
                                        {{ new Date(selectedSlotPlan.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' }) }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="selectedSlotPlan.slot === 'morning'" class="flex items-center gap-2 bg-amber-400 text-slate-900 font-bold px-4 py-2 rounded-lg text-sm">
                                <i class="fas fa-sun"></i> Matin
                            </div>
                            <div v-else class="flex items-center gap-2 bg-blue-400 text-white font-bold px-4 py-2 rounded-lg text-sm">
                                <i class="fas fa-cloud-sun"></i> Après-midi
                            </div>
                        </div>

                        <!-- Infos clés de l'intervention (mappées sur ton JSON actuel) -->
                        <div class="bg-white rounded-xl border border-slate-200 divide-y divide-slate-100">

                            <!-- Nom / Type de l'intervention -->
                            <div class="flex items-center gap-4 p-4">
                                <div class="w-9 h-9 rounded-lg bg-orange-100 text-orange-600 flex items-center justify-center shrink-0">
                                    <i class="fas fa-wrench"></i>
                                </div>
                                <div>
                                    <p class="text-xs text-slate-400">Intervention</p>
                                    <p class="font-bold text-slate-800">{{ selectedEvent?.title || 'Non spécifié' }}</p>
                                </div>
                            </div>

                            <!-- Adresse (via chantier) -->
                            <div class="flex items-center gap-4 p-4">
                                <div class="w-9 h-9 rounded-lg bg-red-100 text-red-500 flex items-center justify-center shrink-0">
                                    <i class="fas fa-map-marker-alt"></i>
                                </div>
                                <div>
                                    <p class="text-xs text-slate-400">Adresse d'intervention</p>
                                    <p class="font-bold text-slate-800">{{ selectedEvent?.chantier?.adresse?.adresse1 }}</p>
                                    <p class="text-sm text-slate-500">
                                        {{ selectedEvent?.chantier?.adresse?.code_postal }} {{ selectedEvent?.chantier?.adresse?.ville }}
                                    </p>
                                </div>
                            </div>

                            <!-- Client (via chantier.client) -->
                            <div class="flex items-center gap-4 p-4">
                                <div class="w-9 h-9 rounded-lg bg-blue-100 text-blue-500 flex items-center justify-center shrink-0">
                                    <i class="fas fa-user"></i>
                                </div>
                                <div>
                                    <p class="text-xs text-slate-400">Client</p>
                                    <p class="font-bold text-slate-800">
                                        {{ selectedEvent?.chantier?.client ? (selectedEvent.chantier.client.prenom + ' ' + selectedEvent.chantier.client.nom) : 'Non renseigné' }}
                                    </p>
                                    <p v-if="selectedEvent?.chantier?.client?.telephone" class="text-sm text-slate-500">
                                        <i class="fas fa-phone text-xs mr-1"></i> {{ selectedEvent.chantier.client.telephone }}
                                    </p>
                                </div>
                            </div>

                            <!-- Durée estimée (via estimation) -->
                            <div class="flex items-center gap-4 p-4">
                                <div class="w-9 h-9 rounded-lg bg-slate-100 text-slate-500 flex items-center justify-center shrink-0">
                                    <i class="fas fa-clock"></i>
                                </div>
                                <div>
                                    <p class="text-xs text-slate-400">Durée estimée</p>
                                    <p class="font-bold text-slate-800">
                                        {{ selectedEvent?.estimation ? selectedEvent.estimation + ' min' : 'Non renseignée' }}
                                    </p>
                                </div>
                            </div>

                        </div>

                        <!-- Boutons d'actions -->
                        <div class="pt-2">
                            <div class="flex gap-3" v-if="!loadingConfirmIntervention">
                                <button
                                    @click="selectedSlotPlan = null"
                                    class="flex-1 py-3 rounded-xl border border-slate-200 text-slate-600 font-semibold text-sm hover:bg-slate-50 transition-all"
                                >
                                    <i class="fas fa-arrow-left mr-1"></i> Modifier le créneau
                                </button>
                                <button
                                    @click="confirmPlanification()"
                                    class="flex-1 py-3 rounded-xl bg-emerald-600 text-white font-bold text-sm hover:bg-emerald-700 transition-all"
                                >
                                    <i class="fas fa-check mr-1"></i> Confirmer la replanification
                                </button>
                            </div>
                            <div v-else class="flex border border-emerald-200 py-3 rounded-xl bg-emerald-50 text-emerald-700 font-bold text-sm items-center justify-center w-full">
                                <i class="fas fa-spinner fa-spin mr-2"></i> Mise à jour du planning en cours...
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </modal>

        <div>
            <div class="bg-white rounded shadow p-4">
                <!-- <planning-planner /> -->
                <!-- :chantier-id="20" -->
                <!-- :intervention-to-plan="2190" -->

                <!-- Interventions à replanifier -->
                <div v-if="interventionsToPlan && interventionsToPlan.length > 0" class="my-4 bg-orange-50 border border-orange-200 rounded-xl p-4">
                    <h3 class="text-xl text-orange-700 font-bold mb-4">
                        <i class="fas fa-undo-alt mr-2"></i> Interventions à replanifier ({{ interventionsToPlan.length }})
                    </h3>
                    <div class="flex flex-col gap-2 max-h-[400px] overflow-y-auto">
                        <div v-for="intervention in interventionsToPlan" :key="intervention.id">
                            <div class="flex items-center justify-between bg-white rounded-lg p-3 shadow transition-all hover:shadow-md">
                                
                                <!-- Infos Intervention -->
                                <div class="flex items-center gap-3">
                                    <div>
                                        <div class="flex items-center gap-2">
                                            <span class="font-medium text-gray-800">{{ intervention.title }}</span>
                                            <!-- Motif de replanification -->
                                            <span v-if="intervention.replan_reason" class="px-2 py-0.5 text-xs bg-red-100 text-red-700 rounded-full font-semibold">
                                                <i class="fas fa-comment-dots mr-1"></i> {{ intervention.replan_reason }}
                                            </span>
                                        </div>
                                        
                                        <!-- Adresse (via chantier) -->
                                        <div v-if="intervention.chantier && intervention.chantier.adresse" class="text-sm text-gray-500 mt-1">
                                            <i class="fas fa-map-marker-alt text-gray-400 mr-1"></i>
                                            {{ intervention.chantier.adresse.adresse1 }}, {{ intervention.chantier.adresse.code_postal }} {{ intervention.chantier.adresse.ville }}
                                        </div>
                                        
                                        <!-- Client & Contact -->
                                        <div v-if="intervention.chantier && intervention.chantier.client" class="text-xs text-gray-400 mt-0.5">
                                            <i class="fas fa-user mr-1"></i> {{ intervention.chantier.client.prenom }} {{ intervention.chantier.client.nom }} 
                                            <span class="mx-1">·</span> 
                                            <i class="fas fa-phone mr-1"></i> {{ intervention.chantier.client.telephone }}
                                        </div>
                                    </div>
                                </div>

                                <!-- Actions -->
                                <div class="flex items-center gap-2">
                                    <button class="flex items-center gap-1 px-4 py-2 rounded-lg bg-slate-600 text-white text-sm hover:bg-slate-700 transition-all" 
                                            @click="selectedEventId = intervention.id; $nextTick(() => { $modal.show('modal-view-intervention-' + intervention.id) })">
                                        <i class="fas fa-eye mr-1"></i> Voir
                                    </button>
                                    
                                    <button @click="selectedEvent = intervention; $nextTick(() => { $modal.show('modal-planification') })" 
                                            class="flex items-center gap-1 px-4 py-2 rounded-lg bg-orange-600 text-white text-sm hover:bg-orange-700 transition-all">
                                        <i class="fas fa-calendar-alt mr-1"></i> Replanifier
                                    </button>
                                    
                                    <button @click="removeIntervention(intervention.id)" 
                                            class="flex items-center justify-center p-2 rounded-lg text-gray-400 hover:text-red-600 hover:bg-red-50 transition-all" 
                                            title="Supprimer">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <planning-half-day
                :days="$account.account.societe.open_days"
                :heure-debut-matin="$account.account.societe.heure_ouverture ? $account.account.societe.heure_ouverture.slice(0, 5) : '08:00'"
                heurefin-matin="12:00"
                heure-debut-apres-midi="12:01"
                :heure-fin-apres-midi="$account.account.societe.heure_fermeture ? $account.account.societe.heure_fermeture.slice(0, 5) : '17:00'"
                :readonly="true"
                @event-click="onEventClick"
                />
            </div>
        </div>
    </div>
</template>

<script>
// import PlanningPlanner from './Components/PlanningPlanner.vue';
import PlanningHalfDay from './Components/PlanningHalfDay.vue';
import ModalInterventionView from '../Intervention/Components/ModalInterventionView.vue';
import ChantierView from '../Chantier/Components/ChantierView.vue';

export default {
    components: {
        // PlanningPlanner
        PlanningHalfDay,
        ModalInterventionView,
        ChantierView
    },
    data() {
        return {
            selectedEventId: null,
            selectedChantierId: null,
            interventionsToPlan: [],
            selectedSlotPlan: null,
            selectedEvent: null,
            loadingConfirmIntervention: false,
        }
    },
    methods: {
        onEventClick(event) {
            // if (event.type == 'intervention') {
            //     this.selectedEventId = event.interventionId;
            //     this.$nextTick(() => {
            //         this.$modal.show("modal-view-intervention-" + event.interventionId)
            //     })
            // }
            // if (event.type == 'chantier') {
                this.selectedChantierId = event.chantierId;
                this.$nextTick(() => {
                    this.$modal.show("modal-view-chantier")
                })
            // }
        },

        async getUnplannedInterventions() {
            try {
                const response = await this.$request.post('/interventions/get-unplanned');
                this.interventionsToPlan = response
            } catch (error) {
                console.error('Erreur lors de la récupération des interventions non planifiées :', error);
                return [];
            }
        },

        async confirmPlanification() {
            try {
                this.loadingConfirmIntervention = true
                await this.$request.post('/interventions/replanifier', {
                    event_id: this.selectedEvent.id,
                    tech_id: this.selectedSlotPlan.techId,
                    date: this.selectedSlotPlan.date,
                    moment_day: this.selectedSlotPlan.slot,
                });
                this.loadingConfirmIntervention = false
                this.$modal.hide('modal-planification');
                this.selectedSlotPlan = null;
                this.selectedEvent = null;
                this.getUnplannedInterventions();
                this.$eventHub.$emit('refresh-planning')
            } catch (error) {
                console.error('Erreur lors de la planification :', error);
            }
        },

        async removeIntervention(eventId) {
            try {
                if (!confirm('Êtes-vous sûr de vouloir supprimer cette planification ?')) {
                    return;
                }
                await this.$request.post('/interventions/events/delete', {
                    planning_event_id: eventId
                });
                this.getUnplannedInterventions();
            } catch (error) {
                console.error('Erreur lors de la suppression de la planification :', error);
            }
        },
    },
    mounted() {
        this.getUnplannedInterventions();
    }       
}
</script>

<style lang="scss" scoped>

</style>